import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { PlanDefault_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	planID: string;
};

export const usePlanEditQuery = ({ hotelID, planID }: Props) => {
	const { data } = useCustomSuspenseQuery(PlanDefault_EditPage_Query, {
		variables: { hotelID, planId: planID },
	});

	return data;
};
